import { NotificationType } from '@prisma/client'
import { buildKeys } from '~/utils/keys/keyBuilder'

/**
 * The `SupportProgramEndSixtyDays` entry was disabled: no longer created since
 * the 60-day reminder became a 2-month one, but kept in the Postgres enum
 * since existing notification records may still reference it. App code
 * therefore treats this field as the active subset below, even though Prisma
 * and zod still surface the full union.
 */
export type ActiveNotificationType = Exclude<
  NotificationType,
  'SupportProgramEndSixtyDays'
>

export const notificationTypeKeys = buildKeys({
  [NotificationType.DueDateToday]: 'Échéance',
  [NotificationType.DueDateOneMonth]: 'Échéance',
  [NotificationType.EndOfSupport]: 'Échéance',
  [NotificationType.EndOfSupportOneMonth]: 'Échéance',
  [NotificationType.NewComment]: 'Commentaire',
  [NotificationType.NewDocument]: 'Document',
  [NotificationType.DocumentExpirationToday]: 'Échéance',
  [NotificationType.DocumentExpirationOneMonth]: 'Échéance',
  [NotificationType.NewFileInstructionElement]: 'Instruction',
  [NotificationType.UpdateFileInstructionElement]: 'Instruction',
  [NotificationType.NewFollowupElement]: 'Synthèse',
  [NotificationType.UpdateFollowupElement]: 'Synthèse',
  [NotificationType.NewSocialSupportSubject]: 'Configuration',
  [NotificationType.ArchiveDueToday]: 'Archive',
  [NotificationType.ArchiveDueOneMonth]: 'Archive',
  [NotificationType.ArchiveDueSevenDays]: 'Archive',
  [NotificationType.SupportProgramEndToday]: 'Échéance',
  [NotificationType.SupportProgramEndTwoMonths]: 'Échéance',
  // Legacy: no longer created, kept so every enum value stays mapped
  [NotificationType.SupportProgramEndSixtyDays]: 'Échéance'
})

export enum NotificationTypeFilterValue {
  DueDate = 'DueDate',
  NewComment = 'NewComment',
  NewItem = 'NewItem',
  Archivage = 'Archivage'
}

export const notificationTypeFilterKeys = buildKeys({
  [NotificationTypeFilterValue.DueDate]: 'Échéances',
  [NotificationType.NewComment]: 'Commentaires',
  [NotificationTypeFilterValue.NewItem]: 'Ajouts par un tiers',
  [NotificationTypeFilterValue.Archivage]: 'Archivage'
})
